import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * QADAM forms
   */
  {
    // 1
    label: 'How would you rate your libido (sex drive)?',
    field: 'qadamLibido',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: 'terrible' },
        { key: '2', value: 'poor' },
        { key: '3', value: 'average' },
        { key: '4', value: 'good' },
        { key: '5', value: 'excellent' }
      ]
    }
  },
  {
    // 2
    label: 'How would you rate your energy level?',
    field: 'qadamEnerge',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: 'terrible' },
        { key: '2', value: 'poor' },
        { key: '3', value: 'average' },
        { key: '4', value: 'good' },
        { key: '5', value: 'excellent' }
      ]
    }
  },
  {
    // 3
    label: 'How would you rate your strength/endurance?',
    field: 'qadamStrength',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: 'terrible' },
        { key: '2', value: 'poor' },
        { key: '3', value: 'average' },
        { key: '4', value: 'good' },
        { key: '5', value: 'excellent' }
      ],
      fullWidth: true
    }
  },
  {
    // 4
    label: 'How would you rate your enjoyment of life?',
    field: 'qadamEnjoyment',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: 'terrible' },
        { key: '2', value: 'poor' },
        { key: '3', value: 'average' },
        { key: '4', value: 'good' },
        { key: '5', value: 'excellent' }
      ],
      fullWidth: true
    },
    fullWidth: true
  },
  {
    // 5
    label: 'How would you rate your happiness level?',
    field: 'qadamHappiness',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: 'terrible' },
        { key: '2', value: 'poor' },
        { key: '3', value: 'average' },
        { key: '4', value: 'good' },
        { key: '5', value: 'excellent' }
      ],
      fullWidth: true
    }
  },
  {
    // 6
    label:
      'How strong are your erections?\n(1=extremely week 5=extremely strong)',
    field: 'qadamErections',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: '1' },
        { key: '2', value: '2' },
        { key: '3', value: '3' },
        { key: '4', value: '4' },
        { key: '5', value: '5' }
      ],
      fullWidth: true
    }
  },
  {
    // 7
    label: 'How would you rate your work performance over the past 4 weeks?',
    field: 'qadamPerformance',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: 'terrible' },
        { key: '2', value: 'poor' },
        { key: '3', value: 'average' },
        { key: '4', value: 'good' },
        { key: '5', value: 'excellent' }
      ],
      fullWidth: true
    }
  },
  {
    // 8
    label: 'How often do you fall asleep after dinner?',
    field: 'qadamAsleep',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: 'never' },
        { key: '2', value: '1~2/week' },
        { key: '3', value: '3~4/week' },
        { key: '4', value: '5~6/week' },
        { key: '5', value: 'every night' }
      ],
      fullWidth: true
    }
  },
  {
    // 9
    label: 'How would you rate your sports ability over the past 4 weeks?',
    field: 'qadamSports',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: 'terrible' },
        { key: '2', value: 'poor' },
        { key: '3', value: 'average' },
        { key: '4', value: 'good' },
        { key: '5', value: 'excellent' }
      ],
      fullWidth: true
    }
  },
  {
    // 10
    label: 'How much height have you lost?',
    field: 'qadamHeight',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: '1', value: '2″ or more' },
        { key: '2', value: '1.5-1.9″' },
        { key: '3', value: '1-1.4″' },
        { key: '4', value: '0.5-0.9″' },
        { key: '5', value: 'none-0.4″' }
      ],
      fullWidth: true
    }
  },
  {
    // 11
    label: 'Your evaluated score',
    field: 'qadamEvaluated',
    type: 'evaluated',
    answer: answers => {
      let score = 0;
      Object.keys(answers).map(key => {
        const answer = answers[key];
        if (Object.keys(answer).length === 1) {
          score += parseInt(Object.keys(answer)[0], 10);
        }
      });
      return score;
    }
  }
];

export default questionsModels;
